/*------------------------------------*\
    #MAIN
\*------------------------------------*/   

(($) => {
    $(() => {
        /**  
         *  If you need to create any additional functions please create them in seperate files
         *  and put them in js/components/FILE_NAME.js, structure them like the example
         *  function below and call them inside of the function chain below, passing in $ as
         *  an argument.
     

         * always use the WW namespace

WW.functionName = function($) {
    ...
    //and return 'this' to allow other functions to continue the WW chain.
    return this;
};

        */

        WW.start($)
            .checkCurrentMediaQuery.init($)
            .navbar($)
            .scrollMagic($)
            .toggleUiPopup($)
            .blockSlider($)
            .masonry($)
            .googlemaps($) 
            .imgControl.init($)
            //.touchSticky($)
            .sectionCollapse($)
            .screenResizeEvents($,
                WW.checkCurrentMediaQuery.init
                // pass in function names as arguments.
                // e.g :
                //WW.navbar,
                //WW.peppermint
            );
    });


    if(document.getElementById('footersendfail')) {
        $('html, body').animate({
            scrollTop: $('#footersendfail').offset().top + 500
        }, 1000);
    }

    if(document.getElementById('contactsendfail')) {
        $('html, body').animate({
            scrollTop: $('#contactsendfail').offset().top - 60
        }, 1000);
    }

})(jQuery);
